import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";

import {SystemProcessDomain, toSystemProcessDomain} from "./system-process-domain";
import {ObjectMappingKind, toObjectMappingKind} from "./object-mapping-kind";

export const SystemProcessExecutionMissingMappingCodec = t.intersection([
  t.type({
    // association
    assocId: t.string,
    systemProcessExecutionId: t.string,
    occurrences: t.number,
    // missing mapping
    systemMissingMappingId: t.string,
    processDomain: t.string,
    systemKey: t.string,
    objectType: t.string,
    mappingKind: t.string,
    externalKey: t.string,
    externalValue: t.string,
  }),
  t.partial({
    // association (optional)
    sampleSourceRef: t.string,
    assocCreateDttm: t.number,
    assocLastModifiedDttm: t.number,

    // missing mapping (optional)
    systemAccountKey: t.string,
    details: t.string,
    firstSeenDttm: t.number,
    lastSeenDttm: t.number,
    mappingCreateDttm: t.number,
    mappingLastModifiedDttm: t.number,
  }),
]);

export type SystemProcessExecutionMissingMapping = t.TypeOf<typeof SystemProcessExecutionMissingMappingCodec>;

@Exclude()
export class SystemProcessExecutionMissingMappingEntity {

  // ─────────────────────────────
  // Association fields
  // ─────────────────────────────

  @Expose()
  assocId!: string;

  @Expose()
  systemProcessExecutionId!: string;

  @Expose()
  occurrences!: number;

  @Expose()
  sampleSourceRef?: string;

  @Expose()
  assocCreateDttm?: number;

  @Expose()
  assocLastModifiedDttm?: number;

  // ─────────────────────────────
  // Missing mapping fields
  // ─────────────────────────────

  @Expose()
  systemMissingMappingId!: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toSystemProcessDomain))
  processDomain!: SystemProcessDomain;

  @Expose()
  systemKey!: string;

  @Expose()
  systemAccountKey?: string;

  @Expose()
  objectType!: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toObjectMappingKind))
  mappingKind!: ObjectMappingKind;

  @Expose()
  externalKey!: string;

  @Expose()
  externalValue!: string;

  @Expose()
  details?: string;

  @Expose()
  firstSeenDttm?: number;

  @Expose()
  lastSeenDttm?: number;

  @Expose()
  mappingCreateDttm?: number;

  @Expose()
  mappingLastModifiedDttm?: number;

  constructor() {
  }

  static from(value: SystemProcessExecutionMissingMapping): SystemProcessExecutionMissingMappingEntity {
    return plainToInstance(SystemProcessExecutionMissingMappingEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<SystemProcessExecutionMissingMapping> {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSON(SystemProcessExecutionMissingMappingCodec, object);
  }

  asTypeValue(): SystemProcessExecutionMissingMapping {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSONNow(SystemProcessExecutionMissingMappingCodec, object);
  }
}
